import { useEffect } from 'react';

import { PageLayout } from '~components/page/PageLayout';
import { FavouriteList } from '~extension/favourite/components/FavouriteList';
import { MediaLibraryFavourites } from '~extension/favourite/components/MediaLibraryFavourites';
import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import { selectAddonsIsFavouriteEnabled } from '~store/selectors';

export default function FavouritesPage() {
  const { hlFavourites } = useLabels(['hlFavourites']);
  const isEnabled = useAppSelector(selectAddonsIsFavouriteEnabled);
  const navigateToDefault = useNavigateToDefault();

  useEffect(() => {
    if (!isEnabled) {
      navigateToDefault();
    }
  }, [isEnabled, navigateToDefault]);

  return (
    <PageLayout title={hlFavourites} className="page--favourites">
      <div className="u-padding-horizontal-xxl u-margin-top-lg">
        <div className="c-view__content">
          <FavouriteList />
          <MediaLibraryFavourites />
        </div>
      </div>
    </PageLayout>
  );
}
